"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importDefault(require("react"));
var lodash_1 = require("lodash");
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var cta_scss_1 = tslib_1.__importDefault(require("./cta.scss"));
var ArrowRightLongIcon_1 = tslib_1.__importDefault(require("../../../../../../icons/compiled/components/ArrowRightLongIcon"));
var TriangleIcon_1 = tslib_1.__importDefault(require("../../../../../../icons/compiled/components/TriangleIcon"));
var twitter_1 = tslib_1.__importDefault(require("../../social-buttons/twitter"));
var youtube_1 = tslib_1.__importDefault(require("../../social-buttons/youtube"));
var facebook_1 = tslib_1.__importDefault(require("../../social-buttons/facebook"));
var types_1 = require("@wix/wix-vod-constants/dist/video-cards/types");
var item_type_1 = require("@wix/wix-vod-constants/dist/api-types/enums/item-type");
var inline_icon_1 = tslib_1.__importDefault(require("../../../../../ui-components/inline-icon/inline-icon"));
var withStyles_1 = require("../../../../../../common/utils/withStyles");
var CardCTA = /** @class */ (function (_super) {
    tslib_1.__extends(CardCTA, _super);
    function CardCTA() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardCTA.prototype.renderSocialButton = function () {
        var _a = this.props, cardData = _a.cardData, labels = _a.labels, isAccessible = _a.isAccessible;
        var facebookButtonTitle = labels.facebookButtonTitle, youtubeButtonTitle = labels.youtubeButtonTitle, twitterButtonTitle = labels.twitterButtonTitle;
        switch (cardData.network) {
            case 'twitter':
                return (react_1.default.createElement(twitter_1.default, { isAccessible: isAccessible, twitterButtonTitle: twitterButtonTitle, cardData: cardData }));
            case 'youtube':
                return (react_1.default.createElement(youtube_1.default, { isAccessible: isAccessible, youtubeButtonTitle: youtubeButtonTitle, cardData: cardData }));
            case 'facebook':
                return (react_1.default.createElement(facebook_1.default, { isAccessible: isAccessible, facebookButtonTitle: facebookButtonTitle, cardData: cardData }));
            default:
                return null;
        }
    };
    CardCTA.prototype.isLiveVideo = function () {
        var itemType = this.props.cardData.itemType;
        return itemType === item_type_1.ItemType.ItemLive;
    };
    CardCTA.prototype.renderDefaultCTA = function () {
        var _a = this.props.cardData, type = _a.type, buttonLabel = _a.buttonLabel;
        var isArrowIcon = lodash_1.includes([types_1.VIDEO_CARD_TYPES.CUSTOM, types_1.VIDEO_CARD_TYPES.PRODUCT], type);
        return (react_1.default.createElement("div", { className: cta_scss_1.default.container },
            react_1.default.createElement("div", { className: cta_scss_1.default.label, "data-hook": "action-card-action-text" },
                this.isLiveVideo() && react_1.default.createElement("div", { className: cta_scss_1.default.circle }),
                buttonLabel),
            react_1.default.createElement("div", { className: cta_scss_1.default.icon }, isArrowIcon ? (react_1.default.createElement(inline_icon_1.default, { icon: react_1.default.createElement(ArrowRightLongIcon_1.default, null), className: cta_scss_1.default['icon-arrow'] })) : (react_1.default.createElement(inline_icon_1.default, { icon: react_1.default.createElement(TriangleIcon_1.default, null), className: cta_scss_1.default['icon-play'] })))));
    };
    CardCTA.prototype.render = function () {
        return this.props.cardData.type === types_1.VIDEO_CARD_TYPES.SOCIAL ? (react_1.default.createElement("div", { className: classnames_1.default(cta_scss_1.default.container, cta_scss_1.default['with-social-button']), "data-hook": "action-card-action-text" }, this.renderSocialButton())) : (this.renderDefaultCTA());
    };
    CardCTA.propTypes = {
        cardData: prop_types_1.default.object,
        isAccessible: prop_types_1.default.bool,
        labels: prop_types_1.default.object,
    };
    CardCTA.defaultProps = {
        labels: {},
    };
    CardCTA = tslib_1.__decorate([
        withStyles_1.withStyles(cta_scss_1.default)
    ], CardCTA);
    return CardCTA;
}(react_1.default.Component));
exports.default = CardCTA;
//# sourceMappingURL=cta.js.map